export enum DerToggleVariant {
    Default = 'default',
    OffDefault = 'off-default',
}
